'use strict';

import defaultTemplate from '../../core/default.html';
import usersListtemplate from './users.list.html';
import usersNewTemplate from './users.new.html';
import usersEditTemplate from './users.edit.html';

import Users from './users.ctrl';

function UsersRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.users', {
      url: '/users',
      template: defaultTemplate
    })
    .state('main.users.list', {
      url: '/list?:searchBy',
      template: usersListtemplate,
      controller: 'UsersListController as vm',
      params: { searchBy: null },
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canIViewUserList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.users.list');
        }
      }
    })
    .state('main.users.new', {
      url: '/new?:from?:fromTab?:email?:phone?',
      template: usersNewTemplate,
      controller: 'UsersNewController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canICreateUserAndLocation()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.users.new');
        }
      }
    })
    .state('main.users.view', {
      url: '/view?:tab?:from?:fromTab?:challengeId?:locationId',
      template: usersEditTemplate,
      controller: 'UsersEditController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canIViewUserList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.users.view');
        }
      }
    })
    .state('main.users.edit', {
      url: '/edit?:tab?:from?:fromTab?:challengeId?:locationId',
      template: usersEditTemplate,
      controller: 'UsersEditController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          const SELECTED_USER_LOCAL_STORAGE_KEY = 'Selected-User';
          let selectedUser = utils.getStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY);
          return PermissionsService.canIEditUser(selectedUser)
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.users.edit');
        }
      }
    });
}

export default angular
  .module('users.router', [
    Users
  ])
  .config(UsersRouter)
  .name;
